import { useCreateQueryKeys as e } from "@maat/store-hooks";
//#region src/profile/useLoginEventsQueryKeys.ts
var t = e("loginEvents", { list: () => ["list"] });
//#endregion
export { t as loginEventsQueryKeys };
